<template>
    <div class="content">
        <div class="container">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Content'
}
</script>

<style>
    .content {
        position: fixed;
        top: 0;
        left: 0;
        margin-left: 100px;
        width: calc(100vw - 100px);
        height: 100vh;
        max-height: 100vh;
        background-color: white;
        padding: 20px;
        overflow: auto;  /* scroll somente content */
        display: flex;
        justify-content: center;
    }
    @media (max-width: 768px) {
        .content {
            margin-left: 65px;
            width: calc(100vw - 65px);
        }
    }
</style>